export default __webpack_public_path__ + "static/media/logo-full-white.160a6c61.png";